import React, { Component } from 'react';
import styled from 'styled-components';
import media from '../../theme/media';
import Header from '../../components/Header/Header';
import { Container, ContainerLarge, Article, Heading, FirstSection, Section, MainColumn } from '../../theme/grid';
import { HeadingH1, HeadingH2, DropCap, BulletedList } from '../../theme/typography';
import Footer from '../../components/Footer/Footer';

const AboutImage = styled.div`
  ${media.tablet`
    display: none
  `}
`;

const AboutSideColumnLeft = styled.div`
    position: absolute;
    width: 200px;
    left: -120px;
    bottom: 110px;
    ${media.tablet`
      order: 2;
      position: static;
      margin: 0 auto;
    `}
    ${media.phone`
      display: none;
    `}
`;

const AboutSideColumnRight = styled.div`
    position: absolute;
    width: 200px;
    right: -120px;
    bottom: 0;
    ${media.tablet`
      order: 2;
      position: static;
      margin: 0 auto;
    `}
`;

export default class About extends Component {
  static propTypes = {};

  render() {
    return (
      <div>
        <Header theme="default" color="#000000"></Header>
        <Article className="default true">
          <Container className="true">
            <Heading className="true">
              <HeadingH2 className="default">About</HeadingH2>
              <HeadingH1>Hi, I'm Michael</HeadingH1>
            </Heading>
            <FirstSection className="true">
              <MainColumn>
                <p><DropCap>I</DropCap>’m a designer & developer with a passion for creating things. I co-founded the interactive division of an animation studio, jERKS iNTERACTIVE. We're currently making an app which lets people draw together.</p>
                <p>In 2018, I helped establish Mozilla's first design system and worked on the Firefox rebranding project as a member of Mozilla’s creative team. My work has been presented at SF Design Week and Mozilla's All Hands Conference</p>
                <p>Back in 2016, I worked at EveryAction where I helped build the campaign tools used by Hillary Clinton's campaign and the Democratic Party.</p>
                <p>I believe in hard work, helping others, exploring ideas, and occasionally stepping away from the canvas.</p>
              </MainColumn>
              <AboutSideColumnRight>
                <img alt="" src={require('../../assets/Home/sleeping.gif')} width="100%" />
              </AboutSideColumnRight>
            </FirstSection>
            <Section className="true">
              <MainColumn>
                <h2>Shoutouts</h2>
                <p>Design is a collaborative art form. These are just a few of the people whose feedback, contribution, and inspiration has been an invaluable part of my design process.</p>
                <BulletedList>
                  <li>
                    <b>EveryAction</b>
                    <p>Justin Lewis, Danielle Ameen, Aurora Nou, Katie Crowell, Rachel Spikula, and the rest of the UDT team.</p>
                  </li>
                  <li>
                    <b>Mozilla</b>
                    <p>Yuliya Gorlovetsky, Vince Joy, Jennifer Rouse, Mark Weaver, Craig Cook, Alex Gibson and the rest of the creative and website teams.</p>
                  </li>
                  <li>
                    <b>Skwiz</b>
                    <p>James Dybvig, Vince Joy, Raymo Ventura, Gabriella Caruso and all of our beta testers.</p>
                  </li>
                </BulletedList>
              </MainColumn>
              <AboutSideColumnLeft>
                <img alt="" src={require('../../assets/Home/contact.gif')} width="100%" />
              </AboutSideColumnLeft>
            </Section>
          </Container>
        </Article>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/containers/About/About.js